/* global axios */
import ApiClient from './ApiClient';

class LeadAppointmentsAPI extends ApiClient {
  constructor() {
    super('lead_appointments', { accountScoped: true });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  // Lista da conta inteira num intervalo — a central de agendamento não é
  // presa a um funil (mostra compromisso manual da corretora também).
  list({ from, to } = {}) {
    return axios.get(this.url, { params: { from, to } });
  }

  // Preferred create path (fatia A+). 404/405 → createForContact fallback.
  create(payload) {
    return axios.post(this.url, payload);
  }

  createForContact(contactId, payload) {
    return axios.post(
      `${this.baseUrl()}/voip_leads/${contactId}/appointments`,
      payload
    );
  }
}

export default new LeadAppointmentsAPI();
